<template>
  <div class="d-flex justify-center align-center" style="height: 100vh;">
    <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
  </div>
</template>

<script lang="ts">
import { auth0Module } from "@/store/dataModule/auth0Module";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Logout",

  mounted() {
    this.logout();
  },

  methods: {
    logout() {
      localStorage.clear();

      auth0Module.logout();
    },
  },
});
</script>